 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({}[chunkId]||chunkId) + "." + {"chunk-14f84e81":"246c8167da7f566d7772","chunk-1ea49e5b":"9cee15a493814d8bc006","chunk-2470b640":"7960d2ba1b0a0ae38728","chunk-27297d52":"7bbfbc8e95073e0cb1e1","chunk-284e079e":"044bb38227fc11bfd18b","chunk-2a6c2c1b":"7074d1f3054d67ff0137","chunk-3e508a2f":"f8993ee22c4f6616d049","chunk-2d0d2f14":"fd754cbc938d6104a6ce","chunk-2082d3a6":"7f925ccc2f0874f067e9","chunk-4cb4c686":"1dad15f013774a66873a","chunk-a1fa74f2":"9bd932330b0d5a6be7b5","chunk-4ed30a2c":"2ac3cf8d3e0a1d4a2905","chunk-2d489c04":"eda494e437fb9a25efef","chunk-107552fb":"b37bc03fe98edf308594","chunk-20fff1d6":"664fa338ca20cf53141b","chunk-450ce1bf":"e1f6178ac5cb201dc948","chunk-8e9da26e":"ed66e6406508c8b99a1a","chunk-5faee8e6":"c9307267d03c931cdb56","chunk-7ecbf452":"19cee1135da2fe526089","chunk-5f3be218":"73d6adf364335060a64e","chunk-594d3daa":"8156e73bc810ca4821a4","chunk-c9363dd4":"eb2e1b96f4ae6342948d","chunk-ee52cfd0":"0bfe51e3e9e18a65e798","chunk-54bf8ea4":"bc75fc95586cc46b407e","chunk-c16e91cc":"c10af2aa748459db82b2","chunk-25f89eb5":"c880ae96984e639b1aa8","chunk-978d57b4":"ae989c838730b3460151","chunk-78ae1690":"1b200b3c4ee0486f73b7","chunk-cfd82d4c":"d726cd9a6f576f20a40e","chunk-58c86f24":"01d3f0f21056b4fa5ccc","chunk-41014f9c":"268531d4bb546d38a257","chunk-59a03f8e":"5095e869991f159c34e9","chunk-aa5b8152":"5735a70d9714da40cf11","chunk-75b1d0ec":"537333d175a17ddf50cf","chunk-54cc4d72":"c4ef353bbeda9a610adc","chunk-49279850":"6ee1787346e5f55edb98","chunk-4b20bd84":"ac3c679850d2e52e2ad4","chunk-47c1412e":"e1585fb8ea1b9365c724","chunk-609b1a6a":"6d0147cac790b496a080","chunk-69a9247c":"01d2b67b9a9a7adb0682","chunk-7d8ebfd4":"94dd49f70f72c442f148","chunk-15b5ca67":"b3ac260137b81e133013","chunk-513e105d":"4b998eb602023f697613","chunk-0a9dda8a":"bd17ebdc0a0e2ab8de28","chunk-268e47dc":"3bb96edc920de51d22a3","chunk-33b48a36":"b9d5ae0816612e84d03a","chunk-e36702f2":"75fc0c745eacc68a331f","chunk-9f28d512":"a1fba172b15d8dea0557","chunk-0aa0d0dd":"ca03ecd901818cd6991d","chunk-2d0e9d6e":"81ecf032e4e2e7bbe36f","chunk-5accc192":"d4d7619f4fc31db55259","chunk-e0671e8a":"0bead0ed94df7fe3e5f2","chunk-2d0e920f":"24c276255aa467f2059e"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://dosi-in.com/design/themes/doins/templates/v4/script_vue/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
